import { connect } from 'react-redux'

import { mapStateToPlaceOrderDetails } from '../PlaceOrder'
import { notifyError } from '../UserMessaging'
import { updateSummary, poNumberChange } from './summaryActions'
import { fetchCartItems } from '../Cart/cartActionCreators'
import CheckoutSummary from './CheckoutSummary'

import { TranslationUtility } from '../../../util/translationUtility';


const mapCheckoutSummaryStateToProps = (state) => {
  const summary = state.entities.Summary;
  const selectedShippingAddressId = state.entities.SelectedShippingAddressId
  const userIsAnonymous = state.constants.UserIsAnonymous;
  const isQuote = state.entities.OrderType === state.constants.onlineQuoteOrderType;
  const shippingAndTaxAreCalculated = userIsAnonymous && !isQuote;
  const translationUtility = new TranslationUtility(state.constants.localizationItems);
  const shippingTotal = shippingAndTaxAreCalculated
    ? summary.ShippingTotalDisplay
    : translationUtility.translateResourceString('/Checkout/Index/Order/ToBeCalculated');
  const taxTotal = shippingAndTaxAreCalculated
    ? summary.TaxTotalDisplay
    : translationUtility.translateResourceString('/Checkout/Index/Order/ToBeCalculated');

  // summary is an array so we can give lines
  // a definite order
  let summaryWithAmounts = [
      translationUtility.translateResourceString('/Checkout/Index/Order/SubTotal'), summary.SubTotalDisplay,
      translationUtility.translateResourceString('/Checkout/Index/Order/ShippingTotal'), shippingTotal,
  ];
  if(summary.DiscountTotal) {
    summaryWithAmounts.push(translationUtility.translateResourceString('/Checkout/Index/Order/Discount'), summary.DiscountTotalDisplay);
  }
  summaryWithAmounts.push(
      translationUtility.translateResourceString('/Checkout/Index/Order/TaxTotal'), taxTotal,
      translationUtility.translateResourceString('/Checkout/Index/Order/Total'), summary.TotalDisplay);
  return {
    summary: summaryWithAmounts,
    summaryEndpoint: state.constants.navigation.cartSummaryEndpoint,
    placeOrderDetails: mapStateToPlaceOrderDetails(state),
    cart: state.entities.CartItems,
    shippingAddress: state.entities.Addresses.find(addr => addr.Id === selectedShippingAddressId),
    shippingOptionId: state.entities.SelectedShippingOptionId,
    couponCode: state.entities.CouponCode,
    localizationItems: state.constants.localizationItems,
    hasRestrictedItems: state.entities.hasRestrictedItems
  };
}

const mapCheckoutSummaryDispatchToProps = dispatch => {
  return {
    onGetSummaryError: (diagnosticMessage) => dispatch(notifyError('Got an error while trying to refresh the summary. Please reload the page and try again, or contact customer service', diagnosticMessage)),
    updateSummary: (placeOrderDetails) => dispatch(updateSummary(placeOrderDetails)),
    onPoChange: (poNumber) => dispatch(poNumberChange(poNumber)),
    onShippingCountryChanged: () => dispatch(fetchCartItems({}))
  }
}

const CheckoutSummaryContainter = connect(mapCheckoutSummaryStateToProps, mapCheckoutSummaryDispatchToProps)(CheckoutSummary)

export default CheckoutSummaryContainter





// WEBPACK FOOTER //
// ./src/Components/checkout/Features/Summary/CheckoutSummaryContainer.js